import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from './models/iapp-config';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;
  static AppConfig: { env: { logoFile: string; name: string; }; };

  constructor(private http: HttpClient) {}

  async load() {
    console.log('window.location.href........', window.location.href);
    const loc = window.location.href;
    const env = this.findEnvironment(loc);
    console.log('env........', env);
    let jsonFile = null;
    if (env === 'uat') {
      console.log('getting the file from the remote server');
      if (loc.includes('/elssuat')) {
        jsonFile = `https://elssuat.cap.org/apmailing-lmsrouter-ui/assets/env/env.uat.json`;
      } else {
        jsonFile = `https://capuatui.cap.org/apmailing-lmsrouter-ui/assets/env/env.uat.json`;
      }
    } else if (env === 'prd') {
      console.log('getting the file from the remote server');
      if (loc.includes('/elss')) {
        jsonFile = `https://elss.cap.org/apmailing-lmsrouter-ui/assets/env/env.prd.json`;
      } else {
        jsonFile = `https://capui.cap.org/apmailing-lmsrouter-ui/assets/env/env.prd.json`;
      }
    } else if (loc.includes('/localdev')) {
      jsonFile = `assets/env/env.${env}.json`;
    } else {
      jsonFile = `assets/env/env.${env}.json`;
    }
    console.log('jsonFile........', jsonFile);
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: IAppConfig) => {
          console.log('key action here: setting the settings', response);
          AppConfig.settings = response as IAppConfig;
          resolve();
        })
        .catch((response: any) => {
          console.log('response', response);
          reject(
            `Could not load file '${jsonFile}': ${JSON.stringify(response)}`
          );
        });
    });
  }

  findEnvironment(currentLocation: any) {
    let env: any;
    switch (true) {
      case currentLocation.includes('/localdev'):
        env = 'local';
        break;
      case currentLocation.includes('/capdev'):
        env = 'dev';
        break;
      case currentLocation.includes('/captst'):
        env = 'tst';
        break;
      case currentLocation.includes('/capuat'):
        env = 'uat';
        break;
      case currentLocation.includes('/elssuat'):
        env = 'uat';
        break;
      case currentLocation.includes('/capsup'):
        env = 'sup';
        break;
      default:
        env = 'prd';
        break;
    }
    return env;
  }
}
